import { HTTP } from '../../utils'

export const getAllConnectors = (page, count) => {
  let url = 'connector/loadConfig?page=' + page + '&count=' + count
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createOrUpdateConnector = (connector) => {
  var url = 'connector/createConfig'
  if (connector.uuid) {
    url = 'connector/updateConfig/' + connector.uuid
  }
  return HTTP().put(url, connector)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}

export const getConnectorDetail = (uuid) => {
  return HTTP().get('connector/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleConnectors = (uuids) => {
  return HTTP().delete('connector/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/connector/api.js